import React from 'react';
import { IMessage } from './BaseChatMessage';
import ChatMessageSent from './ChatMessageSent';
import ChatMessageReceived from './ChatMessageReceived';

type MessageListProps = {
  messages: IMessage[];
};

export default function ChatMessageList({ messages }: MessageListProps) {
  return (
    <>
      {messages.map((message, index) => {
        const created =
          message.createdAt instanceof Date
            ? message.createdAt.getTime()
            : new Date(message.createdAt as any).getTime();
        const key = `${created}-${index}-${message.isOwner ? 'sent' : 'received'}`;

        return message.isOwner ? (
          <ChatMessageSent key={key} keyValue={key} message={message.content} at={message.createdAt} />
        ) : (
          <ChatMessageReceived key={key} keyValue={key} message={message.content} at={message.createdAt} />
        );
      })}
    </>
  );
}
